export default {
  安全提示: "Security Notice",
  安全提示内容:
    "For account security, it is recommended that you change your password immediately.",
  去修改密码: "Change Password",
};
